import React from 'react';
import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {calendarDate} from 'shared/tools';
import {ActionLink, Label, Panel} from 'components';
import EditBasicInfoModal from './EditBasicInfoModal';
import {t} from 'shared/core';

const BasicInformation = observer(({uiState}) => {
  const {employee} = uiState;

  return (
    <Panel className='mb1'>
      <Panel.Header title={t('employees.profile.personal.Basic Information')}>
        {uiState.editDataPermission('::PERSONAL_INFORMATION') &&
          <ActionLink onClick={() => uiState.openBasicInfoModal()}>
            <FormattedMessage id='employees.profile.personal.Edit'/>
          </ActionLink>}
      </Panel.Header>
      <div className='col-12 sm-col-10 pt1'>
        <div className='clearfix mxn1 pb1'>
          <div className='col col-6 px1'>
            <FormattedMessage id='employees.profile.personal.First Name'/>
          </div>
          <div className='col col-6 px1'>
            <Label model={employee} path='firstName'/>
          </div>
        </div>
        <div className='clearfix mxn1 pb1'>
          <div className='col col-6 px1'>
            <FormattedMessage id='employees.profile.personal.Preferred Name'/>
          </div>
          <div className='col col-6 px1'>
            <Label model={employee} path='preferredName'/>
          </div>
        </div>
        <div className='clearfix mxn1 pb1'>
          <div className='col col-6 px1'>
            <FormattedMessage id='employees.profile.personal.Middle Name'/>
          </div>
          <div className='col col-6 px1'>
            <Label model={employee} path='middleName'/>
          </div>
        </div>
        <div className='clearfix mxn1 pb1'>
          <div className='col col-6 px1'>
            <FormattedMessage id='employees.profile.personal.Last Name'/>
          </div>
          <div className='col col-6 px1'>
            <Label model={employee} path='lastName'/>
          </div>
        </div>
        <div className='clearfix mxn1 pb1'>
          <div className='col col-6 px1'>
            <FormattedMessage id='employees.profile.personal.Preferred Last Name'/>
          </div>
          <div className='col col-6 px1'>
            <Label model={employee} path='preferredLastName'/>
          </div>
        </div>
        <div className='clearfix mxn1 pb1'>
          <div className='col col-6 px1'>
            <FormattedMessage id='employees.profile.personal.Current Gender Identity'/>
          </div>
          <div className='col col-6 px1'>
            <Label model={employee} path='genderView' translate={true} />
          </div>
        </div>
        <div className='clearfix mxn1'>
          <div className='col col-6 px1'>
            <FormattedMessage id='employees.profile.personal.Birthdate'/>
          </div>
          <div className='col col-6 px1'>
            <Label model={employee} path='birthDate' render={value => calendarDate(value)}/>
          </div>
        </div>
      </div>
      <EditBasicInfoModal uiState={uiState} />
    </Panel>
  );
});

export default BasicInformation;
